export default "__VITE_ASSET__DPg_y6jR__"